import type { DeliverableAnalytic } from 'types';

export const getNewAnalytic = (deliverableType: string): Partial<DeliverableAnalytic> => ({
  id: Math.random() - 1,
  reach: 0,
  estimatedReach: 0,
  impressions: 0,
  estimatedImpressions: 0,
  interactions: 0,
  linkClicks: 0,
  shares: 0,
  saves: 0,
  websiteClicks: 0,
  stickerTaps: 0,
  profileVisits: 0,
  nextStoryCount: 0,
  exitedCount: 0,
  matchedAttachments: [],
  metricsType: `${deliverableType.replace('_regram', '')}_metrics` as DeliverableAnalytic['metricsType']
});
